export default __webpack_public_path__ + "static/media/ChatGeminiImage.b399c225.png";